import { IconSm, IconSuperTiny } from '@/widgets/components/icon';
import React from 'react';
import { IconButton } from 'rsuite';
import { fadeInAnimation } from '@/app/styles';
import styled from 'styled-components';

export const Wrapper = styled.div`
  ${fadeInAnimation()}

  display: flex;
  background-color: transparent;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media only screen and (max-width: 1480px) {
    margin-left: 38px;
  }

  @media print {
    display: block !important;
    width: 100%;

    @page {
      size: 1079px 1527px !important;
      /* Want small margins on top or bottom to hide the native window.print() header and footers */
      margin: 5mm !important;
    }
  }
`;

export const DetailsWrapper = styled.div`
  display: flex;
  justify-content: center;
  min-width: 1000px;
  max-width: 1300px;
  width: 100%;
  margin: auto;
`;

export const DetailsInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 40%;
`;

export const CityZip = styled.div`
  margin-top: 2px;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #101938;
`;

export const DataGroup = styled.div`
  margin-top: 26px;
  color: rgba(0, 0, 0, 0.85);
`;

export const Label = styled.div`
  font-size: 14px;
  font-weight: 700;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.57;
  letter-spacing: normal;
  color: #101938;
  margin-bottom: 4px;
`;

export const DataItem = styled.div`
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.57;
  letter-spacing: normal;
  margin-bottom: 4px;
`;

// TODO: We are supposed to use this post MVP. If not, remove
export const Dot = styled.div`
  width: 10px;
  height: 10px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  display: inline-block;
  margin-right: 12px;
`;

export const PropertyInfoDataWrapper = styled.div`
  display: flex;
`;

export const StyledIconSuperTiny = styled(IconSuperTiny)`
  width: 11px;
  height: 11px;
  margin-right: 10px;
  opacity: 0.25;
`;

export const CloseIcon = styled(IconSm)`
  color: rgba(0, 0, 0, 0.25);
`;

export const StyledIconButton = styled(IconButton)`
  padding-left: 12px !important;
`;

export const OnlinePlatformIconSizer = styled.div`
  width: 24px;
  height: 24px;
  display: inline-block;
  margin-right: 8px;
  cursor: pointer;
`;

export const AddressAndPrintWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const VerticalAligner = styled.div`
  display: flex;
  align-items: center;
  line-height: 1.57;
  margin-bottom: 4px;
`;

export const Spacer = styled.div`
  max-width: ${(props) => (props.unconstrained ? null : '100px')};
  min-width: 25px;
  width: 100%;

  @media print {
    width: 10px;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const DropdownWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StyledDropdownLabel = styled.div`
  color: rgba(0, 0, 0, 0.5);
  margin-right: 5px;
`;

export const StyledDropdownTitle = styled.div`
  color: #010733;
  text-transform: capitalize;
`;

export const Column = styled.div`
  width: 50%;
`;

export const StyledDropdownItem = styled.div`
  text-transform: capitalize;
`;

const PRDataRowWrapper = styled.div`
  margin-bottom: 4px;
  line-height: 1.57;
`;

const PRDataRowLabel = styled.span`
  font-weight: 700;
`;

/**
 * Rows of data for primary residence info
 *
 * @param {string} label
 * @param {*} value
 */
export function PRDataRow({ label, children }) {
  return (
    <PRDataRowWrapper>
      <PRDataRowLabel>{label}:&nbsp;</PRDataRowLabel>
      {children}
    </PRDataRowWrapper>
  );
}

export const PdfLink = styled.a`
  span {
    color: unset;
    margin-left: 5px;
  }
`;
